export interface FieldMeta {
  label: string;
  hint?: string;
}

const SECTION_TITLES: Record<string, string> = {
  hero: 'Sección principal (Hero)',
  identidad: 'Identidad de la iglesia',
  ministerios: 'Ministerios / Pilares',
  horarios: 'Horarios de servicio',
  header: 'Encabezado de página',
  historia: 'Historia',
  legal: 'Información legal',
  bandera: 'Bandera cuadrangular',
  proposito: 'Misión y visión',
  pilares: 'Cuatro pilares',
  liderazgo: 'Liderazgo',
  valores: 'Valores',
  proximo_evento: 'Próximo evento destacado',
  eventos_mes: 'Eventos del mes',
  actividades_semanales: 'Actividades semanales',
  calendario: 'Calendario',
  cta_final: 'Llamado a la acción',
  recursos: 'Recursos de la iglesia',
  programas: 'Programas de la fundación',
  impacto: 'Impacto social',
  testimonios: 'Testimonios',
  ayudar: 'Cómo ayudar',
  metodos: 'Formas de donar',
  rapida: 'Donación rápida',
  info: 'Información de contacto / confianza',
  form: 'Formulario de contacto',
  mapa: 'Mapa / ubicación',
  logo: 'Logo',
  brand: 'Marca / nombre',
  nav: 'Navegación',
  contacto: 'Datos de contacto',
  social: 'Redes sociales',
  copyright: 'Copyright',
};

const FIELD_LABELS: Record<string, Record<string, Record<string, FieldMeta>>> = {
  INICIO: {
    hero: {
      versiculo: { label: 'Versículo principal', hint: 'Texto bíblico que aparece en la pantalla de inicio.' },
      referencia: { label: 'Referencia bíblica', hint: 'Ej: - Mateo 18:20' },
      cta_unirse: { label: 'Botón "Únete a nosotros"', hint: 'Texto del botón principal.' },
      cta_horarios: { label: 'Botón "Ver horarios"', hint: 'Texto del botón secundario.' },
    },
    identidad: {
      label: { label: 'Etiqueta de sección', hint: 'Pequeño texto superior, ej: Nuestra identidad.' },
      titulo: { label: 'Título', hint: 'Ej: Somos Cuadrangulares.' },
      subtitulo: { label: 'Subtítulo', hint: 'Texto bajo la imagen, ej: Fundada en 1947.' },
      texto_1: { label: 'Párrafo 1', hint: 'Primer párrafo descriptivo.' },
      texto_2: { label: 'Párrafo 2', hint: 'Segundo párrafo descriptivo.' },
      cta: { label: 'Texto del botón', hint: 'Ej: Conocer más.' },
      imagen: { label: 'Imagen', hint: 'Imagen principal de la sección.' },
    },
    ministerios: {
      label: { label: 'Etiqueta de sección', hint: 'Ej: Nuestros pilares.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestros Ministerios.' },
      items: { label: 'Lista de ministerios', hint: 'Cada item lleva icono, título y descripción.' },
    },
    horarios: {
      label: { label: 'Etiqueta de sección', hint: 'Ej: Te esperamos.' },
      titulo: { label: 'Título', hint: 'Ej: Horarios de Servicio.' },
      items: { label: 'Lista de horarios', hint: 'Cada item lleva icono, título, horas y descripción.' },
    },
  },
  NOSOTROS: {
    header: {
      label: { label: 'Etiqueta', hint: 'Ej: Quiénes somos.' },
      titulo: { label: 'Título principal', hint: 'Ej: Acerca de Nosotros.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción del encabezado.' },
    },
    historia: {
      label: { label: 'Etiqueta', hint: 'Ej: Desde 1947.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestra Historia.' },
      parrafos: { label: 'Párrafos', hint: 'Lista de párrafos de la historia.' },
    },
    legal: {
      label: { label: 'Etiqueta', hint: 'Ej: Marco legal.' },
      titulo: { label: 'Título', hint: 'Ej: Somos Cuadrangulares.' },
      texto_1: { label: 'Párrafo legal 1', hint: 'Primer texto legal.' },
      texto_2: { label: 'Párrafo legal 2', hint: 'Segundo texto legal.' },
    },
    bandera: {
      label: { label: 'Etiqueta', hint: 'Ej: Símbolo identitario.' },
      titulo: { label: 'Título', hint: 'Ej: La bandera cuadrangular.' },
      descripcion: { label: 'Descripción', hint: 'Texto explicativo de la bandera.' },
      colores: { label: 'Colores y significados', hint: 'Lista de colores con su significado.' },
      imagen: { label: 'Imagen de la bandera', hint: 'Imagen que se muestra al lado de los colores.' },
    },
    proposito: {
      label: { label: 'Etiqueta', hint: 'Ej: Nuestro propósito.' },
      titulo: { label: 'Título', hint: 'Ej: Misión y Visión.' },
      mision_titulo: { label: 'Título de misión', hint: 'Ej: Nuestra Misión.' },
      mision_texto: { label: 'Texto de misión', hint: 'Descripción de la misión.' },
      vision_titulo: { label: 'Título de visión', hint: 'Ej: Nuestra Visión.' },
      vision_texto: { label: 'Texto de visión', hint: 'Descripción de la visión.' },
    },
    pilares: {
      label: { label: 'Etiqueta', hint: 'Ej: Nuestra doctrina.' },
      titulo: { label: 'Título', hint: 'Ej: Los Cuatro Pilares.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción de los pilares.' },
      items: { label: 'Lista de pilares', hint: 'Cada pilar lleva título, descripción y versículo.' },
    },
    liderazgo: {
      label: { label: 'Etiqueta', hint: 'Ej: Nuestra familia.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestro Liderazgo.' },
      items: { label: 'Líderes', hint: 'Lista de líderes con nombre, cargo y descripción.' },
    },
    valores: {
      label: { label: 'Etiqueta', hint: 'Ej: Lo que nos define.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestros Valores.' },
      items: { label: 'Lista de valores', hint: 'Cada valor lleva icono, título y descripción.' },
    },
  },
  EVENTOS: {
    header: {
      label: { label: 'Etiqueta', hint: 'Ej: Agenda.' },
      titulo: { label: 'Título', hint: 'Ej: Eventos y Actividades.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción.' },
    },
    proximo_evento: {
      badge: { label: 'Insignia', hint: 'Ej: Próximo Evento Especial.' },
      cuenta_regresiva_label: { label: 'Label de cuenta regresiva', hint: 'Ej: Cuenta regresiva.' },
      cuenta_regresiva_titulo: { label: 'Título de cuenta regresiva', hint: 'Use {eventTitle} para el nombre del evento.' },
      cuenta_regresiva_footer: { label: 'Pie de cuenta regresiva', hint: 'Ej: El tiempo avanza...' },
      descripcion_default: { label: 'Descripción por defecto', hint: 'Texto cuando no hay descripción del evento.' },
      cta_reservar: { label: 'Botón reservar', hint: 'Ej: Reservar mi lugar.' },
      cta_mas_info: { label: 'Botón más información', hint: 'Ej: Más información.' },
    },
    eventos_mes: {
      cargando: { label: 'Texto de carga', hint: 'Ej: Cargando eventos...' },
      error: { label: 'Texto de error', hint: 'Ej: No se pudieron cargar los eventos.' },
      vacio: { label: 'Texto sin eventos', hint: 'Ej: No hay eventos programados.' },
      vacio_mes: { label: 'Texto sin eventos este mes', hint: 'Ej: No hay eventos programados para este mes.' },
      label: { label: 'Etiqueta', hint: 'Ej: Programación.' },
      titulo: { label: 'Título', hint: 'Ej: Eventos del Mes.' },
      descripcion: { label: 'Descripción', hint: 'Breve descripción.' },
      boton_inscribirme: { label: 'Botón inscribirme', hint: 'Ej: Inscribirme.' },
    },
    actividades_semanales: {
      label: { label: 'Etiqueta', hint: 'Ej: Siempre presentes.' },
      titulo: { label: 'Título', hint: 'Ej: Actividades Semanales.' },
      descripcion: { label: 'Descripción', hint: 'Breve descripción.' },
      items: { label: 'Actividades', hint: 'Lista de actividades semanales.' },
    },
    calendario: {
      label: { label: 'Etiqueta', hint: 'Ej: Planifica.' },
      titulo: { label: 'Título', hint: 'Ej: Calendario Mensual.' },
      descripcion: { label: 'Descripción', hint: 'Breve descripción.' },
      boton: { label: 'Botón', hint: 'Ej: Ver Calendario Completo.' },
    },
    cta_final: {
      label: { label: 'Etiqueta', hint: 'Ej: Invitación.' },
      titulo: { label: 'Título', hint: 'Ej: ¿Quieres ser parte de nuestros eventos?' },
      descripcion: { label: 'Descripción', hint: 'Texto del llamado a la acción.' },
      boton_unirse: { label: 'Botón unirse', hint: 'Ej: Únete a nosotros.' },
      boton_ubicacion: { label: 'Botón ubicación', hint: 'Ej: Ver Ubicación.' },
    },
  },
  IGLESIA: {
    header: {
      label: { label: 'Etiqueta', hint: 'Ej: Recursos.' },
      titulo: { label: 'Título', hint: 'Ej: Iglesia.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción.' },
    },
    recursos: {
      items: { label: 'Recursos disponibles', hint: 'Lista de recursos con icono, título y descripción.' },
    },
  },
  FUNDACION: {
    header: {
      titulo: { label: 'Título', hint: 'Ej: Fundación Cuadrangular.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción.' },
      versiculo: { label: 'Versículo', hint: 'Texto bíblico del encabezado.' },
      referencia: { label: 'Referencia bíblica', hint: 'Ej: - Mateo 25:35.' },
    },
    programas: {
      label: { label: 'Etiqueta', hint: 'Ej: Nuestra labor.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestros Programas.' },
      items: { label: 'Programas', hint: 'Lista de programas con icono, detalles y descripción.' },
    },
    impacto: {
      label: { label: 'Etiqueta', hint: 'Ej: Nuestro alcance.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestro Impacto.' },
      items: { label: 'Cifras de impacto', hint: 'Lista con número, descripción e icono.' },
    },
    testimonios: {
      label: { label: 'Etiqueta', hint: 'Ej: Historias reales...' },
      titulo: { label: 'Título', hint: 'Ej: Testimonios de Esperanza.' },
      items: { label: 'Testimonios', hint: 'Lista de testimonios con nombre, texto y programa.' },
    },
    ayudar: {
      titulo: { label: 'Título', hint: 'Ej: ¿Cómo Puedes Ayudar?' },
      descripcion: { label: 'Descripción', hint: 'Breve texto.' },
      cards: { label: 'Formas de ayudar', hint: 'Lista de 3 tarjetas con icono, título y descripción.' },
      boton_donar: { label: 'Botón donar', hint: 'Ej: Hacer Donación.' },
      boton_voluntario: { label: 'Botón voluntario', hint: 'Ej: Ser Voluntario.' },
    },
  },
  DONACIONES: {
    header: {
      label: { label: 'Etiqueta', hint: 'Ej: Generosidad.' },
      titulo: { label: 'Título', hint: 'Ej: Donaciones y Ofrendas.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción.' },
      versiculo: { label: 'Versículo', hint: 'Texto bíblico.' },
      referencia: { label: 'Referencia bíblica', hint: 'Ej: - Lucas 6:38.' },
    },
    metodos: {
      label: { label: 'Etiqueta', hint: 'Ej: Contribuye.' },
      titulo: { label: 'Título', hint: 'Ej: Formas de Donar.' },
      descripcion: { label: 'Descripción', hint: 'Breve texto.' },
      items: { label: 'Métodos de donación', hint: 'Lista con título, descripción, icono y detalles.' },
      boton: { label: 'Texto del botón', hint: 'Ej: Donar Ahora.' },
    },
    rapida: {
      label: { label: 'Etiqueta', hint: 'Ej: Rápido.' },
      titulo: { label: 'Título', hint: 'Ej: Donación Rápida.' },
      descripcion: { label: 'Descripción', hint: 'Breve texto.' },
      montos: { label: 'Montos sugeridos', hint: 'Lista de montos.' },
      placeholder: { label: 'Placeholder', hint: 'Ej: Otro monto.' },
      boton: { label: 'Texto del botón', hint: 'Ej: Donar.' },
    },
    info: {
      label: { label: 'Etiqueta', hint: 'Ej: Confianza.' },
      titulo: { label: 'Título', hint: 'Ej: Información Importante.' },
      items: { label: 'Items de confianza', hint: 'Lista con icono, título y descripción.' },
    },
  },
  CONTACTO: {
    header: {
      label: { label: 'Etiqueta', hint: 'Ej: Escríbenos.' },
      titulo: { label: 'Título', hint: 'Ej: Contáctanos.' },
      subtitulo: { label: 'Subtítulo', hint: 'Breve descripción.' },
    },
    info: {
      label: { label: 'Etiqueta', hint: 'Ej: Estamos cerca.' },
      titulo: { label: 'Título', hint: 'Ej: Información de Contacto.' },
      direccion_titulo: { label: 'Título dirección', hint: 'Ej: Dirección.' },
      direccion: { label: 'Dirección', hint: 'Texto completo de la dirección.' },
      telefonos_titulo: { label: 'Título teléfonos', hint: 'Ej: Teléfonos.' },
      telefonos: { label: 'Teléfonos', hint: 'Lista de teléfonos.' },
      email_titulo: { label: 'Título email', hint: 'Ej: Email.' },
      email: { label: 'Emails', hint: 'Lista de correos.' },
      horarios_titulo: { label: 'Título horarios', hint: 'Ej: Horarios de Oficina.' },
      horarios: { label: 'Horarios de oficina', hint: 'Texto de horarios.' },
    },
    form: {
      titulo: { label: 'Título del formulario', hint: 'Ej: Envíanos un Mensaje.' },
    },
    mapa: {
      label: { label: 'Etiqueta', hint: 'Ej: Encuéntranos.' },
      titulo: { label: 'Título', hint: 'Ej: Nuestra Ubicación.' },
      descripcion: { label: 'Descripción', hint: 'Breve texto.' },
      boton: { label: 'Texto del botón', hint: 'Ej: Ver en Google Maps.' },
    },
  },
  HEADER: {
    logo: {
      url: { label: 'Logo del menú superior', hint: 'Imagen que aparece en la barra de navegación.' },
    },
    brand: {
      nombre: { label: 'Nombre de la iglesia', hint: 'Ej: Iglesia Cristiana Cuadrangular.' },
      subtitulo: { label: 'Subtítulo', hint: 'Ej: Central de Apartadó.' },
    },
    nav: {
      login_label: { label: 'Botón de ingreso', hint: 'Ej: Miembros.' },
    },
  },
  FOOTER: {
    brand: {
      logo_url: { label: 'Logo del footer', hint: 'Imagen del pie de página.' },
      nombre: { label: 'Nombre de la iglesia', hint: 'Ej: Iglesia Cristiana Cuadrangular.' },
      subtitulo: { label: 'Subtítulo', hint: 'Ej: Central de Apartadó.' },
      descripcion: { label: 'Descripción', hint: 'Breve texto sobre la iglesia.' },
    },
    contacto: {
      titulo: { label: 'Título de contacto', hint: 'Ej: Contáctanos.' },
      direccion_label: { label: 'Label dirección', hint: 'Ej: Dirección:' },
      direccion: { label: 'Dirección', hint: 'Dirección física.' },
      email_label: { label: 'Label email', hint: 'Ej: ✉️ Email:' },
      email: { label: 'Email', hint: 'Correo electrónico.' },
    },
    horarios: {
      label: { label: 'Etiqueta horarios', hint: 'Ej: 🕐 Horarios de Servicio.' },
      items: { label: 'Horarios', hint: 'Lista de días y horas.' },
    },
    social: {
      label: { label: 'Etiqueta redes', hint: 'Ej: Síguenos:' },
      links: { label: 'Redes sociales', hint: 'Lista con nombre, URL y color.' },
    },
    copyright: {
      texto: { label: 'Texto de copyright', hint: 'Texto del pie derechos reservados.' },
      creditos: { label: 'Créditos', hint: 'Texto de créditos.' },
    },
  },
};

export function getSectionTitle(seccion: string): string {
  return SECTION_TITLES[seccion] || seccion;
}

export function getFieldMeta(pagina: string, seccion: string, clave: string): FieldMeta {
  const meta = FIELD_LABELS[pagina]?.[seccion]?.[clave];
  if (meta) return meta;
  // Fallback: humanizar la clave
  const humanized = clave
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase());
  return { label: humanized };
}
